<template id="roleList">
  <div name="videotype">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">角色列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">用戶</li>
              <li class="breadcrumb-item active">角色列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-programme" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-9"></div>
          <div class="col-sm-3">
            <button
              class="btn btn-block btn-primary btn-sm"
              type="button"
              @click="toRoleAdd()"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>建立角色
            </button>
            <!-- <el-button type="primary" @click="addVideo()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>新增角色
            </el-button>-->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="GetAllRoleList"
                  border
                  row-key="id"
                  v-if="isShow"
                  v-loading="loading"
                >
                  <el-table-column
                    label="角色名稱"
                    prop="sgL_RoleName"
                  ></el-table-column>
                  <el-table-column
                    label="備註"
                    prop="sgL_Remark"
                  ></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="UpdateRole(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-button
                        style="margin-left: 0px"
                        type="primary"
                        size="mini"
                        @click="UpdateMenu(scope.row.id)"
                        >編輯菜單</el-button
                      >
                      <!-- <el-button
                        type="danger"
                        size="mini"
                        @click="delRole(scope.row.id)"
                        >删除</el-button
                      > -->
                      <el-popconfirm
                        title="确定删除吗？"
                        @onConfirm="delRole(scope.row.id)"
                      >
                        <el-button type="danger" size="mini" slot="reference"
                          >删除</el-button
                        >
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      roleList: null,
      loading: true,
      isShow: false,
      visible: false,
    };
  },
  created() {
    this.GetAllRole();
  },
  methods: {
    GetAllRole() {
      this.$api.permissionApi.GetAllRole().then((res) => {
        if (res.data.success) {
          this.roleList = res.data.result.items;
          this.loading = false;
          this.isShow = true;
        } else {
          Message({
            type: "error",
            message: "服務器錯誤",
          });
        }
      });
    },
    toRoleAdd() {
      this.$router.push({ name: "rolePermissions" });
    },
    UpdateRole(id) {
      //跳转组件
      this.$router.push({ name: "rolePermissions", query: { Id: id } });
    },
    UpdateMenu(id) {
      this.$router.push({ name: "roleMenuList", query: { Id: id } });
    },
    delRole(id) {
      let params = {
        Id: id,
      };
      this.$api.permissionApi.DeleteRole(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: "刪除成功",
          });
          this.GetAllRole();
        } else {
          Message({
            type: "error",
            message: "刪除失敗",
          });
        }
      });
    },
  },
  computed: {
    GetAllRoleList() {
      return this.roleList;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminUser/roleList.vue